import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../../Component/Loader/Loader";
import { getRequest, postRequest } from "../../../utils/api";
import DataContext from "../../../utils/context";
import moment from "moment";
import { useParams } from "react-router-dom";
import EditProfileModal from "../modals/EditProfileModal";
import EditBusinessModal from "../modals/EditBusinessModal";

const ViewUserDetails = () => {
  const { id } = useParams();
  const contextValues = useContext(DataContext);
  const [apiError, setApiError] = useState("");
  const [apiSuccess, setApiSuccess] = useState("");
  const [loading, setLoading] = useState(false);// Modal States
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showBusinessModal, setShowBusinessModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [form, setForm] = useState({
    user_first_name: "",
    user_last_name: "",
    user_email: "",
    user_mobile: "",
    user_companyName: "",
    user_website: "",
    user_industry: "",
    user_companySizeRange: "",
    user_plan_name: "",
    user_plan_type: "",
    user_plan_start_date: "",
    user_plan_end_date: "",
    user_whatsapp_type: "",
    user_mail_verification_status: false,
  });

  const [passwordForm, setPasswordForm] = useState({
    newPassword: "",
    confirmPassword: ""
  });

  const mapResponseData = (data) => {
    return {
      user_first_name: data?.user_first_name || "",
      user_last_name: data?.user_last_name || "",
      user_email: data?.user_email || "",
      user_mobile: data?.user_mobile || "",
      user_companyName: data?.user_companyName || "",
      user_website: data?.user_website || "",

      user_country: data?.user_country || "",
      user_state: data?.user_state || "",


      user_industry: data?.user_industry || "",
      user_companySizeRange: data?.user_companySizeRange || "",
      user_plan_name: data?.user_plan_name || "",
      user_plan_type: data?.user_plan_type || "",
      user_plan_start_date: data?.user_plan_start_date || "",
      user_plan_end_date: data?.user_plan_end_date || "",
      user_whatsapp_type: data?.user_whatsapp_type || "",
      user_mail_verification_status: data?.user_mail_verification_status || false,
    };
  };

  const fetchUserDetails = async () => {
    setLoading(true);
    try {
      const response = await getRequest(`/user/userDetails/${id}`);
      if (response.status === "success") {
        setForm(mapResponseData(response.data));
        contextValues.setUserData(response.data);
      } else if (response.status === "session_expired") {
        localStorage.removeItem("USER_TOKEN");
        window.location.href = "/";
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "user_country" ? { user_state: "" } : {}),
    }));
  };

  // --- API: UPDATE PROFILE ---
  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setApiError("");
    setApiSuccess("");

    try {
      const response = await postRequest(`/user/updateUserDetails/${id}`, form);
      if (response.status === "success") {
        fetchUserDetails();

        setShowProfileModal(false);
        setShowBusinessModal(false);
        toast.success(response.message || "Profile updated successfully");
      } else {
        setApiError(response.message);
      }
    } catch (error) {
      setApiError("Error updating profile");
    } finally {
      setLoading(false);
    }
  };

  // --- API: UPDATE PASSWORD ---
  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setApiError("Passwords do not match");
      return;
    }
    if (passwordForm.newPassword.length < 6) {
      setApiError("Password must be at least 6 characters");
      return;
    }

    setLoading(true);
    setApiError("");
    setApiSuccess("");

    try {
      const response = await postRequest(`/user/updateUserPassword/${id}`, { newPassword: passwordForm.newPassword });
      if (response.status === "success") {
        toast.success("Password updated successfully");
        setPasswordForm({ newPassword: "", confirmPassword: "" });
      } else {
        setApiError(response.message);
      }
    } catch (error) {
      setApiError("Error updating password");
    } finally {
      setLoading(false);
    }
  };

  // --- API: VERIFY EMAIL MANUALLY ---
  const handleVerifyEmail = async () => {
    setLoading(true);
    try {
      const response = await postRequest(`/user/verifyUserEmail/${id}`, {});
      if (response.status === "success") {
        toast.success("Email verified successfully");
        fetchUserDetails(); // Refresh data to show badge
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Error verifying email");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    if (contextValues.userData) {
      setForm(mapResponseData(contextValues.userData));
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="hk-pg-wrapper">
        <div className="hk-pg-body py-0">
          <div className="contactapp-wrap">
            <div className="contactapp-content">
              <div className="contactapp-detail-wrap">
                <header class="contact-header">
                  <div class="d-flex align-items-center">
                    <nav aria-label="breadcrumb">
                      <ol class="breadcrumb  mb-0">
                        <li class="breadcrumb-item"><a href="contact.html">User & Customer</a></li>
                        <li class="breadcrumb-item active" aria-current="page">
                          {form.user_companyName || `${form.user_first_name} ${form.user_last_name}`}
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div class="contact-options-wrap">
                    <div class="d-flex fs-7 align-items-center">1 of 30</div>
                    <a class="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover contactapp-info-toggle" href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Previous"><span class="icon"><span class="feather-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></span></span></a>
                    <a class="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover contactapp-info-toggle" href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Next"><span class="icon"><span class="feather-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></span></span></a>
                    <a class="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable" href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Collapse">
                      <span class="icon">
                        <span class="feather-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg></span>
                        <span class="feather-icon d-none"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg></span>
                      </span>
                    </a>
                  </div>
                </header>
                <div className="contact-body contact-detail-body">
                  <div data-simplebar className="nicescroll-bar">
                    <div className="d-flex flex-xxl-nowrap flex-wrap">
                      <div className="contact-info w-xxl-25 w-100">
                        <div className="text-center">
                          <div class="relative group text-center">
                            <div class="avatar avatar-lg avatar-soft-danger avatar-rounded">
                              <img class="avatar-img" src="/dist/img/avatar12.jpg" alt="Avatar" />
                            </div>
                          </div>
                          <div class="cp-name text-truncate mt-2">
                            {`${form.user_first_name} ${form.user_last_name}`}
                          </div>
                          <ul className="hk-list hk-list-sm justify-content-center mt-2">
                            <li>
                              <a class="btn btn-icon btn-soft-primary btn-rounded" href="#">
                                <span class="icon">
                                  <span class="feather-icon"></span>
                                </span>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div class="separator-full"></div>
                        <div className="card">
                          <div className="card-header">
                            <h6 class="mb-0">Profile Information</h6>
                            <button className="btn btn-xs btn-icon btn-rounded btn-light" type="button" onClick={() => setShowProfileModal(true)}>
                              <span class="icon"><i class="ri-pencil-fill"></i></span>
                            </button>
                          </div>
                          <div className="card-body">
                            <ul class="cp-info">
                              <li>
                                <span>First name</span>
                                <span>{form.user_first_name || "N/A"}</span>
                              </li>
                              <li>
                                <span>Last name</span>
                                <span>{form.user_last_name || "N/A"}</span>
                              </li>
                              <li>
                                <span>Email</span>
                                <span>{form.user_email || "N/A"}</span>
                              </li>
                              <li>
                                <span>Phone</span>
                                <span>{form.user_mobile || "N/A"}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="separator-full"></div>
                        <div className="card">
                          <div className="card-header">
                            <h6 class="mb-0">WABA Profile</h6>

                          </div>
                          <div className="card-body">
                            <ul class="cp-info">
                              <li>
                                <span>WABA Number</span>
                                <span>{contextValues.userData?.user_meta_analytics?.display_phone_number || "N/A"}</span>
                              </li>
                              <li>
                                <span>Verified Status</span>
                                <span>
                                  <span className={`badge radius-sm ${contextValues.userData?.user_whatsapp?.isWabaConnected ? "bg-neon-light-4" : "bg-red-light-4"}`}>
                                    {contextValues.userData?.user_whatsapp?.isWabaConnected ? "CONNECTED" : "DISCONNECTED"}
                                  </span>
                                </span>
                              </li>
                              <li>
                                <span>Message Limit</span>
                                <span>{form.user_meta_analytics?.whatsapp_business_manager_messaging_limit || "N/A"}</span>
                              </li>
                              <li>
                                <span>Quality Rating</span>
                                <span>{contextValues.userData?.user_meta_analytics?.quality_rating || "N/A"}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="separator-full"></div>
                        <div className="card">
                          <div className="card-header">
                            <h6 class="mb-0">Business Profile</h6>
                            <button className="btn btn-xs btn-icon btn-rounded btn-light" type="button" onClick={() => setShowBusinessModal(true)}>
                              <span class="icon"><i class="ri-pencil-fill"></i></span>
                            </button>
                          </div>
                          <div className="card-body">
                            <ul class="cp-info">
                              <li>
                                <span>Company Name</span>
                                <span>{form.user_companyName || "N/A"}</span>
                              </li>
                              <li>
                                <span>Website</span>
                                <span>
                                  {form.user_website ? (
                                    <a href={form.user_website} target="_blank" rel="noreferrer" className="text-primary">
                                      {form.user_website}
                                    </a>
                                  ) : (
                                    "N/A"
                                  )}
                                </span>
                              </li>
                              <li>
                                <span>Country</span>
                                <span>{contextValues.userData?.country_details?.country_name || "N/A"}</span>
                              </li>
                              <li>
                                <span>State</span>
                                <span>{contextValues.userData?.state_details?.state_name || "N/A"}</span>
                              </li>
                              <li>
                                <span>Industry</span>
                                <span>{form.user_industry || "N/A"}</span>
                              </li>
                              <li>
                                <span>Company Size</span>
                                <span>{form.user_companySizeRange || "N/A"}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="separator-full"></div>
                        <div className="card">
                          <div className="card-header">
                            <h6 class="mb-0">Other Information</h6>

                          </div>
                          <div className="card-body">
                            <ul class="cp-info">
                              <li>
                                <span>Register on</span>
                                <span>{moment(contextValues.userData?.createdAt).format('DD MMMM, YYYY')}</span>
                              </li>
                              <li>
                                <span>Last login at</span>
                                <span>{moment(contextValues.userData?.updatedAt).format('DD MMMM, YYYY')}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="contact-more-info">
                        <ul className="nav nav-tabs nav-line nav-icon nav-light">
                          <li class="nav-item">
                            <a class="nav-link active" data-bs-toggle="tab" href="#tab_summery">
                              <span class="nav-icon-wrap">
                                <div className="feather-icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-zap"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                                </div>
                              </span>
                              <span class="nav-link-text">Summary</span>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#">
                              <span class="nav-icon-wrap">
                                <span class="feather-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-activity"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg></span></span>
                              <span class="nav-link-text">Subscription</span>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#">
                              <span class="nav-icon-wrap">
                                <span class="feather-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-square"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg></span></span>
                              <span class="nav-link-text">Invoices</span>
                            </a>
                          </li>
                        </ul>
                        <div className="tab-content mt-0">
                          <div className="tab-pane fade show active" id="tab_summery">
                            <div className="card card-border">
                              <div className="card-body">
                                <h5 className="mb-3">Plan Details</h5>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Render Modals */}
      <EditProfileModal
        show={showProfileModal}
        onHide={() => {
          setShowProfileModal(false);
          setForm(mapResponseData(contextValues.userData)); // Reset form to API state on cancel
        }}
        form={form}
        handleInputChange={handleInputChange}
        onSave={handleProfileUpdate}
        isSaving={isSaving}
      />

      <EditBusinessModal
        show={showBusinessModal}
        onHide={() => {
          setShowBusinessModal(false);
          setForm(mapResponseData(contextValues.userData)); // Reset form to API state on cancel
        }}
        form={form}
        handleInputChange={handleInputChange}
        onSave={handleProfileUpdate}
        isSaving={isSaving}
      />
    </>
  );
};

export default ViewUserDetails;